import React, { Fragment } from 'react';
import { connect } from "react-redux";
import { delete_study } from "../../../services/api/manage_study";

import { GPAP_Button_Light } from "../../../gpap-lib/components/Button_Collection";
import GPAP_Tooltip from "../../../gpap-lib/components/GPAP_Tooltip";

import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, IconButton } from "@mui/material";
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';


function DeleteDialog(props) {
    const [open, setOpen] = React.useState(false);
    const [success, setSuccess] = React.useState(false);
    const [message, setMessage] = React.useState(false);


    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setSuccess(false);
        setMessage(false);
        setOpen(false);
    };

    const handleDelete = () => {

        const nextgpap_server = window.config.apis_configuration.api_nextgpap_server;
        let data = {
            study_id: props.study_id

        };

        delete_study(nextgpap_server, props.token, data)
            .then(resp => {

                if(resp.ok){
                    setSuccess(true);
                    return resp.json()
                }
                else{
                    setSuccess(false);
                    return resp.json()
                }


            }
              )
            .then(json => {
                setMessage(json.info);
                props.go_to_study();
            })



    };


    const firstDialog = () => {

        return <Fragment>
            <DialogContent>
                <DialogContentText id="alert-dialog-description">
                    All analysis and queries will also be delete from our database
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose} color="primary">
                    No, I don't want
                </Button>
                <Button onClick={handleDelete} color="primary" autoFocus>
                    Yes, I want to delete it
                </Button>
            </DialogActions>
        </Fragment>


    };

    const secondDialog = () => {

        return <Fragment>
            <DialogContent>
                <DialogContentText id="alert-dialog-description">
                    {message}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose} color="primary">
                   Close
                </Button>
            </DialogActions>
        </Fragment>


    };


    const getButton = () => {

        if(props.onlyIcon){

            return <GPAP_Tooltip title={"Delete the study"}><IconButton onClick={handleClickOpen}>
                <DeleteForeverIcon/>
            </IconButton>
            </GPAP_Tooltip>

        }
        else{
            return  <GPAP_Button_Light onClick={handleClickOpen} startIcon={<DeleteForeverIcon/>}>
                Delete
            </GPAP_Button_Light>
        }



    }

    return (
        <Fragment>
            {getButton()}
            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">{(!message) ? "Are you sure to delete this study?" : "Response"}</DialogTitle>
                {(!message)
                    ? firstDialog()
                    : secondDialog()}
            </Dialog>
        </Fragment>
    );
}

function mapStateToProps (state) {
    if(state.authorization!==undefined)
    {
        return {   token: state.authorization.token}
    }
}





export default connect(mapStateToProps,null)(DeleteDialog);